import React, { useState } from 'react';
import './index.scss';

const Timeline = () => {
  const [events, setEvents] = useState([
    {
      date: 'February-Present 2025',
      title: 'Architect / Software Engineer 2, Bank of America.',
      description: [
        'Pioneered an AI virtual assistant leveraging Azure OpenAI and internal process data, demonstrating AI-driven customer solutions and accelerating process comprehension for end-users',
        'Architected enterprise-grade data movement and data compression architecture between on-prem and cloud, collaborating with security and product stakeholders to ensure secure, at-scale transmission using Azure services, AWS, and Kafka.',
        'Developed and submitted an invention disclosure for a microservice-based system that models business processes and predicts preventable outages using SARIMA and time series anomaly detection on Splunk telemetry data.',
      ],
      expanded: false,
    },
    {
      date: 'July 2023 - February 2025',
      title: 'Software Engineer, Bank of America.',
      description: [
        'Led Proof of Concept (POC) initiatives for data platforms, including Snowflake and Databricks, driving adoption of end-to-end data workflows and enabling enterprise-wide data sharing and training across the bank',
        'Conducted GenAI testing with RAG and LLaMA models in Databricks for audio-to-text and script generation, demonstrating interest and practical experience with AI/ML technologies',
        'Built intuitive GUIs with ReactJS and developed a digital twin using Cytoscape and A* search for real-time outage visualization, improving operational resilience and reducing average time-to-diagnosis by 20%.',
        'Designed and implemented CI/CD pipelines and built FastAPIs with Node.js and Python, improving data latency by 35%, showcasing experience with system/service/app development and optimization',
        'Built and optimized ML models for an AI-driven license compliance system, tuning 20+ hyperparameters to reach 90% accuracy and automate 60% of manual review across 100K+ records.',
      ],
      expanded: false,
    },
    {
      date: 'February 2022 - May 2023',
      title: 'Sofware Engineer Intern, Bank of America.',
      description: [
        'Partnered with business, product, and technology teams across the organization to evolve machine learning and data science capabilities within the bank',
        'Provided technical support to apply state-of-art machine learning / artificial intelligence utilizing technologies such as ML flow, Nbdev, and IBM CP4D to the data scientist Phoenix platform. I made a demo and built and utilized new technologies such as ML flow and Nbdev for the team inside the bank.',
        'Gathered and translated internal and external client requirements into technical design specifications suitable for the application of machine learning',
      ],
      expanded: false,
    },
    {
      date: 'March 2021 - December 2021',
      title: 'Teaching Assistant & Research Assistant, University of North Carolina at Charlotte.',
      description: [
        'Led academic support and instruction for core Computer Science courses (Data Structures & Algorithms, Database Implementation) at the University of North Carolina at Charlotte, serving as a Teaching Assistant Lead and Grader for two terms (10 months total).',
        'Enhanced student learning and engagement by designing and implementing problem-driven database SQL learning materials including mini-labs, mini-projects, and course projects, while actively running help sessions and providing one-on-one tutoring.',
        'Applied advanced technical skills as an Undergraduate Research Assistant, focusing on volumetric program testing and 3D computer vision by utilizing Linux, C++, Aruco calibration for intrinsic/extrinsic parameters, point cloud overlay (k4a), and researching Iterative Closest Point (ICP) methods and IoT applications.',
      ],
      expanded: false,
    },
  ]);

  const handleItemClick = (index) => {
    setEvents((prevEvents) => {
      const updatedEvents = prevEvents.map((event, idx) => {
        if (idx === index) {
          return { ...event, expanded: !event.expanded };
        }
        return event;
      });
      return updatedEvents;
    });
  };

  return (
    <div className="timeline-container">
      {events.map((event, index) => (
        <div
          className={`timeline-item ${event.expanded ? 'expanded' : ''}`}
          key={index}
          onClick={() => handleItemClick(index)}
        >
          <div className="timeline-marker"></div>
          <div className="timeline-content">
            <h2>{event.title}</h2>
            {event.expanded ? (
              <div>
                {event.description.map((desc, descIndex) => (
                  <p key={descIndex} dangerouslySetInnerHTML={{ __html: desc }} />
                ))}
              </div>
            ) : (
              <>
                <div className="more">
                  <p>Click for more</p>
                </div>
                <div className="date">{event.date}</div>
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Timeline;
